class MenuView extends Backbone.View
  events: ->

  show: ->
    @el.classList.add("show")

  hide: ->
    @el.classList.remove("show")

module.exports = MenuView
